var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87322 14.5C8.87322 14.8462 9.15384 15.1268 9.5 15.1268C9.84616 15.1268 10.1268 14.8462 10.1268 14.5L8.87322 14.5ZM9.9432 3.0568C9.69843 2.81202 9.30157 2.81202 9.0568 3.0568L5.06797 7.04562C4.8232 7.2904 4.8232 7.68725 5.06797 7.93203C5.31275 8.1768 5.7096 8.1768 5.95438 7.93203L9.5 4.38641L13.0456 7.93203C13.2904 8.1768 13.6873 8.1768 13.932 7.93203C14.1768 7.68725 14.1768 7.2904 13.932 7.04562L9.9432 3.0568ZM9.5 14.5L10.1268 14.5L10.1268 3.5L9.5 3.5L8.87322 3.5L8.87322 14.5L9.5 14.5Z",
    fill: "#00C05B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.942ed941b94581868b3b05a6e1a4cbea.svg";
export { ForwardRef as ReactComponent };